import { render, staticRenderFns } from "./answerJudges.vue?vue&type=template&id=d882d920&scoped=true"
import script from "./answerJudges.vue?vue&type=script&lang=js"
export * from "./answerJudges.vue?vue&type=script&lang=js"
import style0 from "./answerJudges.vue?vue&type=style&index=0&id=d882d920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d882d920",
  null
  
)

export default component.exports